import { createElement } from 'react';

import PropTypes from 'prop-types';

const PictureWrapper = ({ sources, children }) => (
  <picture className="gw-gallery__picture">
    {sources.map(({ srcSet, type, media, ...sourceRest }) => {
      return (
        <source
          key={srcSet}
          type={type}
          media={media}
          srcSet={srcSet}
          {...sourceRest}
        />
      );
    })}
    {children}
  </picture>
);

PictureWrapper.propTypes = {
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      srcSet: PropTypes.string,
      type: PropTypes.string,
      media: PropTypes.string,
    }),
  ),
  children: PropTypes.element,
};

PictureWrapper.defaultProps = {
  sources: PropTypes.shape([
    {
      srcSet: '',
      type: 'image',
      media: '',
    },
  ]),
  children: createElement('div'),
};

export default PictureWrapper;
